import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-filter.component.scss';
var ArticleFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleFilter, _super);
    function ArticleFilter(element) {
        return _super.call(this, element) || this;
    }
    ArticleFilter.prototype.init = function () {
        this.form = this.element.querySelector('#article-form-filter');
        this.selectButtons = Array.from(this.element.querySelectorAll('.article-filter__form-field--select-button'));
        this.selectItems = Array.from(this.element.querySelectorAll('.article-filter__form-field--select-box-item'));
        this.clearButton = this.element.querySelector('.js-clear-filters');
    };
    ArticleFilter.prototype.bindEvents = function () {
        var _this = this;
        if (this.selectButtons) {
            this.selectButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                _this.closeAllSelects();
                var parent = element.closest('.article-filter__form-field--container');
                var box = parent.querySelector('.article-filter__form-field--select-box');
                box.classList.toggle('article-filter__form-field--select-box-active');
            }); });
        }
        if (this.selectItems) {
            this.selectItems.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var value = element.getAttribute('data-value');
                var name = element.getAttribute('data-name');
                var parent = element.closest('.article-filter__form-field--container');
                var button = parent.querySelector('.article-filter__form-field--select-button');
                var box = parent.querySelector('.article-filter__form-field--select-box');
                button.innerHTML = name;
                box.classList.toggle('article-filter__form-field--select-box-active');
            }); });
        }
        if (this.clearButton) {
            this.clearButton.addEventListener('click', function (event) {
                _this.form.reset();
            });
        }
    };
    ArticleFilter.prototype.closeAllSelects = function () {
        this.selectButtons.map(function (item) {
            var element = item;
            var parent = element.closest('.article-filter__form-field--container');
            var box = parent.querySelector('.article-filter__form-field--select-box');
            box.classList.remove('article-filter__form-field--select-box-active');
        });
    };
    return ArticleFilter;
}(Base));
export { ArticleFilter };



//////////////////
// WEBPACK FOOTER
// ./components/article-filter/article-filter.component.ts
// module id = 99
// module chunks = 0